module.exports = __webpack_public_path__ + "img/collection-weddingRingsFancy@2x.9c026c3.webp";